const QCCampaignActionTypes = {
    GET_CAMPAIGN: 'GET_CAMPAIGN',
    UPDATE_CAMPAIGN: 'UPDATE_CAMPAIGN',
    UPDATE_CALL_CAMPAIGNS: 'UPDATE_CALL_CAMPAIGNS',
    CALL_CAMPAIGNS: 'CALL_CAMPAIGNS',
    SET_DATA: 'SET_DATA',
    IS_EDIT: 'IS_EDIT',
    GET_CALL_CAMPAIGN: 'GET_CALL_CAMPAIGN',
    SET_INDEX_CALL: 'SET_INDEX_CALL',
    SET_TOTAL_CALL: 'SET_TOTAL_CALL',
    UPDATE_BATCH: 'UPDATE_BATCH',
    UPDATE_ASR_CRITERIA: 'UPDATE_ASR_CRITERIA',
    UPDATE_CRITERIA: 'UPDATE_CRITERIA',
    DATA_INPUT_SUGGESTION: 'DATA_INPUT_SUGGESTION',
    UPDATE_DATA_INPUT: 'UPDATE_DATA_INPUT',
    REPORT_METRICS: 'REPORT_METRICS',
    GET_REPORT_METRICS: 'GET_REPORT_METRICS',
    CREATE_REPORT_METRIC: 'CREATE_REPORT_METRIC',
    UPDATE_REPORT_METRIC: 'UPDATE_REPORT_METRIC',
    DELETE_REPORT_METRIC: 'DELETE_REPORT_METRIC',
    SWAP_REPORT_METRIC: 'SWAP_REPORT_METRIC',
}

export default QCCampaignActionTypes
